/* eslint-disable */
// @ts-nocheck
// THIS FILE IS GENERATED, DO NOT EDIT!
import * as Urql from 'urql';

import type * as Types from '../../../../../../generated/graphql/types';

export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type LoyaltyHvcUserCashbackPercentageQueryVariables = Types.Exact<{
  platform: Types.Platform;
  channel: Types.Channel;
  market: Types.Market;
}>;

export type LoyaltyHvcUserCashbackPercentageQuery = { __typename?: 'Query' } & {
  loyaltyHVCLevelStatus: Types.Maybe<
    { __typename?: 'LoyaltyHVCLevelStatus' } & {
      level: { __typename?: 'LoyaltyHVCLevel' } & Pick<
        Types.LoyaltyHvcLevel,
        'cashbackPercentage'
      >;
    }
  >;
};

export const LoyaltyHvcUserCashbackPercentageDocument = /*#__PURE__*/ `
    query LoyaltyHvcUserCashbackPercentage($platform: Platform!, $channel: Channel!, $market: Market!) {
  loyaltyHVCLevelStatus(channel: $channel, platform: $platform, market: $market) {
    level {
      cashbackPercentage
    }
  }
}
    `;

export function useLoyaltyHvcUserCashbackPercentageQuery(
  options: Omit<
    Urql.UseQueryArgs<LoyaltyHvcUserCashbackPercentageQueryVariables>,
    'query'
  >,
) {
  return Urql.useQuery<
    LoyaltyHvcUserCashbackPercentageQuery,
    LoyaltyHvcUserCashbackPercentageQueryVariables
  >({ query: LoyaltyHvcUserCashbackPercentageDocument, ...options });
}
